import { Fragment } from "react";

export default function NotFoundPage() {
    return <Fragment>
        <h1>No Found Page</h1>
    </Fragment>
}